import { z } from 'zod'

const technicianProfileSchema = z.object({
  workingDays: z.array(z.number().int().min(1).max(7)).min(1, 'Mindestens ein Arbeitstag'),
  shiftStart: z.string().min(1, 'Schichtbeginn ist erforderlich'),
  shiftEnd: z.string().min(1, 'Schichtende ist erforderlich'),
  breakStart: z.string().min(1, 'Pausenbeginn ist erforderlich'),
  trades: z.array(z.number().int().nonnegative()),
})

function buildUserFormSchema(opts: { requirePassword: boolean }) {
  const passwordField = opts.requirePassword
    ? z.string().min(8, 'Mindestens 8 Zeichen')
    : z.string().min(8, 'Mindestens 8 Zeichen').optional()

  return z.object({
    email: z.string().email('Ungueltige E-Mail'),
    name: z.string().min(1, 'Name ist erforderlich'),
    roles: z.array(z.enum(['WORKER', 'MANAGER', 'DIRECTOR', 'SUPERUSER'])).nonempty('Mindestens eine Rolle auswählen'),
    technicianProfile: technicianProfileSchema.optional(),
    password: passwordField,
  }).superRefine((data, ctx) => {
    if (data.roles.includes('WORKER') && !data.technicianProfile) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Techniker-Profil ist erforderlich',
        path: ['technicianProfile'],
      })
    }
    const tp = data.technicianProfile
    if (tp?.shiftStart && tp?.shiftEnd && tp.shiftEnd <= tp.shiftStart) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Schichtende muss nach Schichtbeginn liegen',
        path: ['technicianProfile', 'shiftEnd'],
      })
    }
  })
}

export const userFormSchema = buildUserFormSchema({ requirePassword: false })
export const userFormSchemaWithPassword = buildUserFormSchema({ requirePassword: true })

export type UserFormValues = z.infer<typeof userFormSchema>
